/*!
 * @module ui-router-page-title
 * @description Page Title directive for angular-ui-router
 * @version v1.0.13
 * @link https://github.com/sibiraj-s/ui-router-page-title
 * @licence MIT License, https://opensource.org/licenses/MIT
 */
(function(){"use strict";var t=function(a,e){return{restrict:"A",scope:{},link:function(t,n){e.onStart({},function(t){var e=function(){return n[0].innerText||"Default Title"},i=t.to().data&&t.to().data.pageTitle?t.to().data.pageTitle:e();a(function(){n.text(i)},0,!1)})}}};t.$inject=["$timeout","$transitions"],angular.module("uiRouterTitle",[]).directive("pageTitle",t)}).call(this);
//# sourceMappingURL=page-title.min.js.map